import { render, staticRenderFns } from "./addBaseActive.vue?vue&type=template&id=7c846aa5&scoped=true"
import script from "./addBaseActive.vue?vue&type=script&lang=js"
export * from "./addBaseActive.vue?vue&type=script&lang=js"
import style0 from "./addBaseActive.vue?vue&type=style&index=0&id=7c846aa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c846aa5",
  null
  
)

export default component.exports